<template>
  <div>
    <!-- Sidebar -->
    <div class="sidebar" id="sidebar">
      <vue-custom-scrollbar class="scroll-area" :settings="settings" @ps-scroll-x="scrollHanle">
        <div class="sidebar-menu">
          <ul>
            <li>
              <div class="row">
                <div class="col-md-12 padding__img-sidebar">
                  <div class="profile-img-wrap edit-img">
                    <img
                      class="inline-block"
                      src="../../../assets/user.jpg"
                      alt="user"
                      @error="changeImage"
                    />
                    <!-- <img
                      class="inline-block"
                      :src="getProfileAccount.instagram_profile_picture_url"
                      alt="user"
                      @error="changeImage"
                    /> -->
                  </div>
                </div>
                <div class="col-md-12 offset-1 sidebar__information">
                  <h4 class="text-primary m-t-0 mb-2">
                    <span>{{getProfileAccount.username}}</span>
                  </h4>
                  <h4 class="text-primary m-t-0 mb-0">
                    <span>{{getProfileAccount.instagram_name}}</span>
                  </h4>
                  <!-- <div class="small doj text-muted m-t-0 mb-0">
                    💰Whatsapp Marketing
                    <br />✉Whatsapp Blast
                    <br />🕹Whatsapp Chatbot
                    <br />🔁Whatsapp Rotator
                    <br />www.waajo.id
                  </div> -->
                </div>
              </div>
            </li>

            <li class="menu-title sidebar__space">&nbsp;</li>
            <li class="settings" :class="{'active': currentpage === 'instagram_analytics_profile'}">
              <router-link :to="'/instagram/analytics/profile?instagram_id=' + $route.query.instagram_id">
                <i class="la la-building"></i>
                <span>Profile</span>
              </router-link>
            </li>
            <li
              class="localization"
              :class="{'active': currentpage === 'instagram_analytics_posts'}"
            >
              <router-link :to="'/instagram/analytics/posts?instagram_id=' + $route.query.instagram_id ">
                <i class="la la-file"></i>
                <span>Posts</span>
              </router-link>
            </li>
            <li
              class="localization"
              :class="{'active': currentpage === 'instagram_analytics_media'}"
            >
              <router-link :to="'/instagram/analytics/media?instagram_id=' + $route.query.instagram_id">
                <i class="la la-image"></i>
                <span>Media</span>
              </router-link>
            </li>
            <li class="index">
              <router-link to="/instagram/accounts/list_official">
                <i class="la la-arrow-left"></i>
                <span>Back</span>
              </router-link>
            </li>
          </ul>
        </div>
      </vue-custom-scrollbar>
    </div>
    <!-- Sidebar -->
  </div>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
export default {
  components: {
    vueCustomScrollbar
  },
  computed: {
    currentpage() {
      return this.$route.name;
    },
    isJoinAffiliate() {
      return this.$store.state.referral.isJoin;
    },
    getProfileAccount(){
      return this.$store.state.instagramAccountOfficial.profileAccount
    }
  },
  data() {
    return {
      settings: {
        suppressScrollX: false
      },
      activeClass: "active"
    };
    //  isactive : true
  },
  async created() {
    await this.loadProfile()
  },
  methods: {
    scrollHanle(evt) {
      console.log(evt);
    },
    loadProfile() {
      this.$store.dispatch('instagramAccountOfficial/getProfile', this.$route.query.instagram_id)
    },
    changeImage(event) {
      // event.target.src = "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"         
      event.target.src="../../../assets/user.jpg"
    }
  }
};
</script>
<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}
.sidebar {
  height: 100vh;
  overflow: auto;
}

.sidebar::-webkit-scrollbar {
  width: 7px;
}

/* Track */
.sidebar::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 5px grey;  */
  box-shadow: none;
  border-radius: 10px;
}

/* Handle */
.sidebar::-webkit-scrollbar-thumb {
  /* background: red;  */
  border-radius: 10px;
  /* background: rgb(204, 204, 204); */
  background-color: transparent;
}

/* Handle on hover */
.sidebar::-webkit-scrollbar-thumb:hover {
  /* background: #b30000;  */
  background: rgb(204, 204, 204);
}
.sidebar-menu ul ul a.class-active {
  color: #00c5fb;
  text-decoration: underline;
}

.mini-sidebar .padding__img-sidebar {
 padding-inline: 23px;
}

.profile-img-wrap {
  width: min(100%, 120px);
  aspect-ratio: 1;
  height: auto;
  margin-inline: 5px;
}

.profile-img-wrap img {
  object-fit: cover;
  width: min(100%, 120px);
  aspect-ratio: 1;
  height: auto;
}

.sidebar__information,
.mini-sidebar.expand-menu .sidebar__information,
.mini-sidebar .slide-nav .sidebar__information {
  margin-top: 0;
  transition: all .2s ease;
  opacity: 1;
}

.mini-sidebar .sidebar__information {
  opacity: 0;
  pointer-events: none;
  margin-top: calc(-100% - 30px);
  transition: all .2s ease;
}

.slide-nav .sidebar__information {
  opacity: 1;
  pointer-events: auto;
  margin-top: 0;
}

.mini-sidebar.expand-menu .profile-img-wrap.edit-img, 
.mini-sidebar .slide-nav .profile-img-wrap.edit-img {
  margin-bottom: 30px;
}

.mini-sidebar .profile-img-wrap.edit-img {
  margin-bottom: 0;
}

</style> 
  


// WEBPACK FOOTER //
// src/views/instagram/instagramAnalytics/sidebar.vue